import axios from 'axios';
import constants from '../constants/constant';

function arrayFromResponse(response, key) {
  const value = response?.data?.[key];
  return Array.isArray(value) ? value : [];
}

export default class ReportCatalogService {
  static async getDefinedReportCounts({ clientId, clientCode, userId }) {
    const requests = [
      axios.get(`${constants.BACKEND_DOMAIN}/api/report-templates`),
      clientId
        ? axios.get(`${constants.BACKEND_DOMAIN}/api/client-custom-reports`, { params: { client_id: clientId } })
        : Promise.resolve(null),
      userId && clientCode
        ? axios.get(`${constants.BACKEND_DOMAIN}/api/filters`, {
          params: { user_id: userId, client_code: clientCode, type: 'customize' },
        })
        : Promise.resolve(null),
    ];

    const [templatesResult, clientCustomResult, userCustomResult] = await Promise.allSettled(requests);
    const templates = templatesResult.status === 'fulfilled'
      ? arrayFromResponse(templatesResult.value, 'templates')
      : [];
    const clientCustomReports = clientCustomResult.status === 'fulfilled'
      ? arrayFromResponse(clientCustomResult.value, 'custom_reports')
      : [];
    const userCustomReports = userCustomResult.status === 'fulfilled' && Array.isArray(userCustomResult.value?.data)
      ? userCustomResult.value.data
      : [];

    const standard = templates.filter((template) => ['weekly', 'monthly'].includes(template.report_type)).length;
    const custom = clientCustomReports.length + userCustomReports.length;

    return {
      standard,
      custom,
      total: standard + custom,
      isAvailable: templatesResult.status === 'fulfilled',
    };
  }
}

